import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/members/applicants/main"));

const AllApplicant = () => {
  return (
    <Suspense fallback={<CircularLoader />}>
      <Main />
    </Suspense>
  );
};

export default AllApplicant;
